export const defaultStoryArgs = {
	disableMocks: false,
	apiEnvironment: 'dev',
	clientId: 'ashlink.code',
	redirectUri: 'https://dev.ashlink.com/auth/callback',
	ineligibleRegistration: false,
	eligibilityURL: '/testEligibilityURL',
	logOutLink: '/testLogOutLink',
	enableSSO: false,
	showMFAFeatures: false,
	termsURL: '/test-terms',
	blob: 'string',
	path: 1,
	hasOwnProvider: false,
};

export const defaultStoryAuthArgs = {
	...defaultStoryArgs,
	ssId: 'fake-ssId',
};
